import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "m4.99 12.46 6.169-9.596c.54-.84 1.841-.457 1.841.54V10h5.168a1 1 0 0 1 .842 1.54l-6.169 9.596c-.54.84-1.841.457-1.841-.54V14H5.832a1 1 0 0 1-.841-1.54"
    }
  )
);
var SvgActivityFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ActivityFilled_default = SvgActivityFilled;

export { ActivityFilled_default as default };
